import { translate, translateFormatter, type RichTextFormatter } from '@/domains/core/localization/translate';
export const {
  createYourAccountTitle
} = translate({
  "createYourAccountTitle": "Create your account in just 3 minutes"
});
export const createYourAccountWelcomeOffer = translateFormatter<{
  couponAmount: string;
}>("And get {couponAmount} off* your first order", undefined, undefined, "en");
export const createYourAccountWelcomeOfferMultiCoupon = translateFormatter<{
  couponAmount: string;
}>("And get {couponAmount} off* on your first purchases", undefined, undefined, "en");
export const createYourAccountWelcomeOfferExpired = translateFormatter<{
  strong: RichTextFormatter;
}>("Up to 20% off your ManoManoPro products", undefined, undefined, "en");